import React, { useEffect } from 'react';

import { Dialog, TextField } from '@material-ui/core';
import PropTypes from 'prop-types';

import LogoVTEX from '../../../../assets/images/VTEXlogo.png';
import {ButtonPrimary} from '../../../../shared/components';
import { useGetVtexCredentials } from '../../hooks/use-get-vtex-credentials';
import { useSetVtexCredentials } from '../../hooks/use-set-vtex-credentials';
import { BootstrapDialogTitle } from '../BootstrapDialogTitle';
import { DivActions, ContentModal } from '../styles';

export function ModalVtex({ open, handleClose, storeId }) {
  const { getVtexCredentials, credentials, setCredentials } =
    useGetVtexCredentials({ storeId });
  const { setVtexCredentials } = useSetVtexCredentials();

  useEffect(() => {
    if (open) {
      getVtexCredentials(storeId);
    }
  }, [open]);

  return (
    <Dialog fullWidth={600} open={open} onClose={handleClose}>
      <BootstrapDialogTitle onClose={handleClose} logo={LogoVTEX}>
        Linkar conta com VTEX
      </BootstrapDialogTitle>
      {credentials && (
        <ContentModal>
          <TextField
            id="vtexAccountName"
            label="Nome da conta VTEX *"
            variant="outlined"
            fullWidth
            value={credentials.vtexAccountName}
            onChange={(e) =>
              setCredentials({
                ...credentials,
                vtexAccountName: e.target.value.trim(),
              })
            }
          />
          <TextField
            id="appKey"
            label="Chave do APP *"
            variant="outlined"
            fullWidth
            value={credentials.appKey}
            onChange={(e) =>
              setCredentials({ ...credentials, appKey: e.target.value.trim() })
            }
          />
          <TextField
            id="appToken"
            label="Token APP *"
            variant="outlined"
            fullWidth
            value={credentials.appToken}
            onChange={(e) =>
              setCredentials({
                ...credentials,
                appToken: e.target.value.trim(),
              })
            }
          />
        </ContentModal>
      )}
      <DivActions>
        <ButtonPrimary.Normal
          width="100%"
          label="LINKAR CONTA"
          onClick={async () => {
            await setVtexCredentials({ credentials, storeId });
            handleClose();
          }}
        />
      </DivActions>
    </Dialog>
  );
}

ModalVtex.propTypes = {
  storeId: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
